export default __webpack_public_path__ + "c6e3cc0168efde2bd5c9b0ea75114b66.jpg";